import script from "./StepItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepItem.vue?vue&type=script&setup=true&lang=ts"

import "./StepItem.vue?vue&type=style&index=0&id=29b98a62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b98a62"]])

export default __exports__